import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { AccountsService } from './accounts.service';

/**
 * Route resolver that ensures account IDs are loaded (with TTL check).
 * Attach to any route that needs fresh `accountIds`.
 */
export const accountIdsResolver: ResolveFn<string[]> = async () => {
  return inject(AccountsService).ensureAccountIds();
};
